import { PLATFORM_OPTIONS, MITIGATION_TYPES } from '@kentik/ui-shared/mitigations/constants';

import adaptiveFlowspecMethodSerializations from './adaptiveFlowspecMethodSerializations';
import flowspecMethodSerializations from './flowspecMethodSerializations';
import a10MethodSerializations from './a10MethodSerializations';
import rtbhMethodSerializations from './rtbhMethodSerializations';

function serializeMethodType(data) {
  const { type } = data;

  switch (type) {
    case MITIGATION_TYPES.RTBH:
      return rtbhMethodSerializations.serialize(data[type]);
    case MITIGATION_TYPES.A10:
      return a10MethodSerializations.serialize(data[type]);
    case MITIGATION_TYPES.FLOWSPEC:
      return flowspecMethodSerializations.serialize(data[type]);
    case MITIGATION_TYPES.ADAPTIVE_FLOWSPEC:
      return adaptiveFlowspecMethodSerializations.serialize(data[type]);
    default:
      return data[type];
  }
}

function deserializeMethodType(data, passedType) {
  // Try to Infer type if none passed
  const type = passedType || PLATFORM_OPTIONS.find((option) => data[option.value])?.value;

  switch (type) {
    case MITIGATION_TYPES.RTBH:
      return rtbhMethodSerializations.deserialize(data[type]);
    case MITIGATION_TYPES.A10:
      return a10MethodSerializations.deserialize(data[type]);
    case MITIGATION_TYPES.FLOWSPEC:
      return flowspecMethodSerializations.deserialize(data[type]);
    case MITIGATION_TYPES.ADAPTIVE_FLOWSPEC:
      return adaptiveFlowspecMethodSerializations.deserialize(data[type]);
    default:
      return data[type];
  }
}

export default {
  deserializeMethodType,
  serializeMethodType
};
